// *** 三方库 ***
import React, { FC } from "react";
// *** 公共组件  ***
// *** 公共业务组件 ***

// *** redux  ***
// *** hooks相关 ***
// *** API接口 ***

// *** 工具相关 ***

// *** 页面业务组件 ***
// *** 类型文件相关 ***
// *** 样式文件相关 ***
import styles from "./index.module.less";

const Card: FC = () => {
  return (
    <div className={styles.Card}>
      <div className={styles.Card__Skeleton} aria-hidden="true">
        <div className={styles.Card__Skeleton__Bar} style={{ width: 37 }}></div>
        <div className={styles.Card__Skeleton__Bar} style={{ width: 84 }}></div>
        <div className={styles.Card__Skeleton__Bar} style={{ width: 70 }}></div>
        <div className={styles.Card__Skeleton__Bar} style={{ width: 84 }}></div>
        <div className={styles.Card__Skeleton__Bar} style={{ width: 70 }}></div>
      </div>
    </div>
  );
};

const memoWrapper = React.memo(Card);

export { memoWrapper as Card };
